
/**
 * 公共js的统一出口
 */

import serve from './serve.js';
import utils from './utils.js';
import date from './date.js';

export default {
    serve: serve,
    utils: utils,
    date: date
};


// WEBPACK FOOTER //
// ./src/common/js/index.js